import { render, staticRenderFns } from "./CustomDate.vue?vue&type=template&id=23add163&"
import script from "./CustomDate.vue?vue&type=script&lang=js&"
export * from "./CustomDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports